<template>
  <label class="form-label" :class="{ 'has-error': hasError }">
    <slot>Label</slot>
    <span v-if="isRequired" class="form-label__required">&nbsp;*</span>
  </label>
</template>

<script>
export default {
  name: 'FormLabel',
  props: {
    hasError: Boolean,
    isRequired: Boolean,
  },
};
</script>

<style lang="scss">
.form-label {
  display: inline-block;
  font-weight: bold;
  margin-bottom: 6px;
  position: relative;
  font-size: 16px;

  &.has-error,
  &__required {
    color: $color-error;
  }
}
</style>
